import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateMeta } from "../../store/actions/metaAction";
import { checkPermissions } from "../../helpers/authentication/checkPermissions";

const FaqIndex = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "جميع الأسئلة الشائعة",
				breadcrumb: "الأسئلة الشائعة",
				button: {
					permissions: ["post-create"],
					show: true,
					text: "اضافة سؤال جديد",
					link: "/faq/create",
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/faq/all`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setData(response.data.data);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
				setLoading(false);
			});
	};

	const handleDelete = postID => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/posts/${postID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				onStart();
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<section>
			{loading && <Loader />}
			{data.map(item =>
				item.categories.map(category => (
					<div key={category.id} className="faq">
						{category.posts.map(post => (
							<div key={post.id} className="faqItem">
								<div className="faqTitle">
									<Link
										to={
											checkPermissions(["post-edit"])
												? `/faq/show/${post.id}`
												: "/"
										}
										key={post.id}
									>
										<h4>{post.data.title}</h4>
									</Link>
									{checkPermissions(["post-delete"]) && (
										<button onClick={() => handleDelete(post.id)}>
											<i className="fas fa-trash"></i>
										</button>
									)}
								</div>
								{post.data.questions.map(question => (
									<div className="question">{question.question}</div>
								))}
							</div>
						))}
					</div>
				))
			)}
		</section>
	);
};

export default FaqIndex;
